import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileCTA from "@/components/layout/StickyMobileCTA";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LocationsIndex from "@/pages/LocationsIndex";
import LocationDetail from "@/pages/LocationDetail";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App font-sans text-slate-800 bg-[#f8fbff] antialiased min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/locations" element={<LocationsIndex />} />
          <Route path="/locations/:slug" element={<LocationDetail />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
